import { Link } from "react-router-dom";
import about from "../../assets/img/About-home.webp";
import { MdDoubleArrow } from "react-icons/md";

import "./About.css";
export default function About() {
  return (
    <>
      <section className="about section-spacing-x section-spacing-y">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-4 mb-3 mb-lg-0">
              <div className="about-img">
                <img
                  src={about}
                  className="img-fluid"
                  alt="Diamond Earings | Best Diamond Certification in India | Sreehari Diamond Laboratory "
                />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="about-content">
                <h2 className="heading">Best Diamond Laboratory in India</h2>
                <p className="mb-1">
                  Sreehari Diamond Laboratory has been proud to be at the
                  forefront of the lab-grown diamond revolution in India.
                  Founded with a vision to transform the diamond industry
                  through innovation, ethics, and sustainability, our laboratory
                  in Tamil Nadu combines cutting-edge technology with a passion
                  for craftsmanship borne from India's rich heritage. Our
                  graders are the most professional in the diamond business,
                  with great experience and a sharp eye for detail from our
                  gemologists. We provide certificates for natural diamonds,
                  diamond jewelry, and lab-grown diamonds. We have the
                  experience of seeing the diamond analysis. Our gemologist is
                  an alumnus of IDI Surat is a premier institution focused on
                  education and training within the gem and jewelry sector,
                  particularly diamonds.{" "}
                </p>{" "}
                <div className="service-read-more mb-3 mt-3">
                  <Link to="/about-us">
                    Read More
                    <MdDoubleArrow />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
